module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delete-events text-dark"
  }, [(!_vm.isInDCalendar) ? _c('div', {
    staticClass: "delete-event__options"
  }, [_c('DDropdown', [_c('ul', {
    staticClass: "large-list",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('li', {
    on: {
      "click": _vm.setDelete
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale].delete_events_onward))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isReadyForModal) ? _c('div', {
    ref: "d_modal_delete_event"
  }, [(_vm.isModal) ? _c('Modal', {
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "delete-events___modal text-dark",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "delete-events___modal__header",
    style: ({
      backgroundColor: _vm.bgColor
    })
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale].are_you_sure))])]), _vm._v(" "), _c('div', {
    staticClass: "delete-events___modal__form"
  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale].do_you_want_to_delete_this_and_all_in_same_timeslot))]), _vm._v(" "), _c('div', {
    staticClass: "delete-events___modal__footer"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].cancel))]), _vm._v(" "), _c('button', {
    staticClass: "bttn--warning bttn--red bttn marg-10-left",
    on: {
      "click": _vm.deleteEvents
    }
  }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale].delete_events_onward) + "\n            ")])])])])]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0629c0ab!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/DeleteEventOnward.vue
// module id = 1456
// module chunks = 1